import React from 'react';
import { setClassNames } from 'ddc-classnames-js';
import PropTypes from 'prop-types';

const ArrowNavButton = ({
	direction,
	name,
	isButtonEnabled,
	pageLink,
	onClick
}) => {
	const commonArrowIconClasses = ['ddc-icon', 'p-3'];

	const arrowIconClasses = [
		...commonArrowIconClasses,
		`ddc-icon-skinny-arrow-${direction}`,
		isButtonEnabled ? '' : 'opacity-50'
	];

	return (
		<a
			href={pageLink}
			name={name}
			aria-label={name}
			disabled={!isButtonEnabled}
			onClick={onClick}
		>
			<i
				className={setClassNames(arrowIconClasses)}
				aria-hidden="true"
				role="presentation"
				tabIndex="-1"
			/>
		</a>
	);
};

ArrowNavButton.propTypes = {
	direction: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	isButtonEnabled: PropTypes.bool.isRequired,
	pageLink: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired
};
export default ArrowNavButton;
